import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ AGREGAR ESTE IMPORT
import { getLogsAuditoria } from '../services/auditoriaService';
import { obtenerFechaLocal, formatearHoraRD } from '../utils/dateUtils';
import '../styles/AuditoriaDashboard.css';

const AuditoriaDashboard = () => {
  const [logs, setLogs] = useState([]);
  const [timelineRegistro, setTimelineRegistro] = useState([]);
  const [timelineCorrelacion, setTimelineCorrelacion] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLog, setSelectedLog] = useState(null);
  const [filters, setFilters] = useState({ tabla: '', registro_id: '', correlation_id: '', q: '' });
  const navigate = useNavigate(); // ✅ AGREGAR ESTE HOOK

  useEffect(() => {
    cargarLogs();
  }, []);

  const cargarLogs = async (params = filters) => {
    try {
      setLoading(true);
      const cleanParams = Object.fromEntries(Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined));
      const data = await getLogsAuditoria(cleanParams);
      setLogs(data);
      if (selectedLog) {
        const refreshed = data.find(log => log.id === selectedLog.id);
        if (refreshed) setSelectedLog(refreshed);
      }
    } catch (error) {
      console.error("❌ Error cargando logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const cargarTimeline = async (log) => {
    setSelectedLog(log);
    try {
      const [porRegistro, porCorrelacion] = await Promise.all([
        getLogsAuditoria({
          tabla: log.tabla,
          registro_id: log.registro_id,
          timeline: 'registro',
          sort: 'asc',
          limit: 200,
        }),
        log.correlation_id
          ? getLogsAuditoria({
              correlation_id: log.correlation_id,
              timeline: 'correlation',
              sort: 'asc',
              limit: 200,
            })
          : Promise.resolve([]),
      ]);

      setTimelineRegistro(porRegistro);
      setTimelineCorrelacion(porCorrelacion);
    } catch (error) {
      console.error('❌ Error cargando timeline de auditoría:', error);
    }
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters(current => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await cargarLogs(filters);
  };

  if (loading) return <div className="loading-container"><div className="spinner"></div><p>Cargando trazabilidad...</p></div>;

  return (
    <div className="auditoria-container">
      <header className="auditoria-header">
        <div className="header-content">
          <h1>🛡️ Panel de Auditoría y Trazabilidad</h1>
          <p>Historial técnico de movimientos - Proyecto Constructora</p>
        </div>
        
        {/* ✅ MODIFICAR ESTA SECCIÓN - AGREGAR BOTÓN DE CONFIGURACIÓN */}
        <div className="header-buttons">
          <button 
            className="btn-configurar"
            onClick={() => navigate('/configuracion/auditoria-externa')}
            title="Configurar exportación de logs"
          >
            ⚙️ Configuración Externa
          </button>
          
          <button className="btn-refrescar" onClick={cargarLogs}>
            🔄 Actualizar Datos
          </button>
        </div>
      </header>

      <form className="auditoria-filters" onSubmit={handleSubmit}>
        <input name="tabla" placeholder="Tabla" value={filters.tabla} onChange={handleFilterChange} />
        <input name="registro_id" placeholder="Registro ID" value={filters.registro_id} onChange={handleFilterChange} />
        <input name="correlation_id" placeholder="Correlation ID" value={filters.correlation_id} onChange={handleFilterChange} />
        <input name="q" placeholder="Buscar acción o usuario" value={filters.q} onChange={handleFilterChange} />
        <button type="submit" className="btn-refrescar">Filtrar</button>
      </form>

      <div className="auditoria-card">
        <div className="table-responsive">
          <table className="auditoria-table">
            <thead>
              <tr>
                <th>Fecha / Hora</th>
                <th>Responsable e IP</th>
                <th>Acción / Módulo / Empresa</th>
                <th>Contexto</th>
                <th>Detalle de Cambios</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr><td colSpan="5" className="no-records">No hay movimientos registrados.</td></tr>
              ) : (
                logs.map((log) => (
                 <tr key={log.id} className={`log-row ${selectedLog?.id === log.id ? 'selected' : ''}`} onClick={() => cargarTimeline(log)}>
                    {/* Fecha y Hora */}
                    <td className="timestamp-cell">
                      <div className="date-main">{obtenerFechaLocal(log.created_at)}</div>
                      <div className="time-sub" style={{ fontSize: '0.8rem', color: '#6b7280' }}>
                        {formatearHoraRD(log.created_at)}
                      </div>
                    </td>

                    {/* Responsable, Email e IP */}
                    <td className="user-cell">
                      <div className="user-info">
                        <span className="user-name-tag">{log.usuario?.nombre || 'Sistema'}</span>
                        <span className="user-email">{log.usuario?.email || 'N/A'}</span>
                        <div className="connection-info">
                          <span className="ip-badge">🔒 {log.ip_address || '127.0.0.1'}</span>
                        </div>
                      </div>
                    </td>

                    {/* Acción y Tabla */}
                    <td className="action-cell">
                      <span className={`badge ${log.accion?.toLowerCase()}`}>
                        {log.accion}
                      </span>
                      <div className="table-tag">📂 {log.tabla}</div>
                      <div className="table-tag">🏢 {log.empresa?.nombre || `Empresa #${log.empresa_id || 'N/A'}`}</div>
                    </td>

                    <td className="device-cell">
                      <div className="agent-info">
                        {log.user_agent?.includes('Chrome') ? '🌐 Chrome' : 
                         log.user_agent?.includes('Firefox') ? '🦊 Firefox' : '💻 Navegador'}
                      </div>
                      <div className="reg-id">Ref ID: #{log.registro_id}</div>
                      <div className="reg-id">Corr: {log.correlation_id || '—'}</div>
                      <div className="reg-id">Origen: {log.origin_event_id || '—'}</div>
                      <div className="reg-id">Motivo: {log.motivo || '—'}</div>
                    </td>

                    {/* Cambios JSON */}
                    <td className="changes-cell">
                      <div className="json-wrapper">
                        {log.accion === 'UPDATE' && (
                          <div className="json-box old">
                            <span>Anterior:</span>
                            <pre>{JSON.stringify(log.valor_anterior, null, 1)}</pre>
                          </div>
                        )}
                        <div className="json-box new">
                          <span>{log.accion === 'INSERT' ? 'Insertado:' : 'Actual:'}</span>
                          <pre>{JSON.stringify(log.valor_nuevo, null, 1)}</pre>
                        </div>
                        {log.metadata && (
                          <div className="json-box meta">
                            <span>Metadata:</span>
                            <pre>{JSON.stringify(log.metadata, null, 1)}</pre>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {selectedLog && (
        <div className="auditoria-detail-grid">
          <div className="auditoria-card">
            <div className="timeline-card-header">
              <h3>Timeline por registro</h3>
              <span>{selectedLog.tabla} #{selectedLog.registro_id}</span>
            </div>
            <div className="timeline-list">
              {timelineRegistro.map(item => (
                <div key={`registro-${item.id}`} className="timeline-item">
                  <div className="timeline-item-title">{item.accion}</div>
                  <div className="timeline-item-sub">{obtenerFechaLocal(item.created_at)} {formatearHoraRD(item.created_at)}</div>
                  <div className="timeline-item-sub">{item.usuario?.nombre || item.usuario_nombre || 'Sistema'}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="auditoria-card">
            <div className="timeline-card-header">
              <h3>Timeline financiero</h3>
              <span>{selectedLog.correlation_id || 'Sin correlation_id'}</span>
            </div>
            <div className="timeline-list">
              {timelineCorrelacion.length === 0 ? (
                <div className="timeline-item"><div className="timeline-item-sub">Sin eventos correlacionados.</div></div>
              ) : timelineCorrelacion.map(item => (
                <div key={`corr-${item.id}`} className="timeline-item">
                  <div className="timeline-item-title">{item.accion} · {item.tabla} #{item.registro_id}</div>
                  <div className="timeline-item-sub">{obtenerFechaLocal(item.created_at)} {formatearHoraRD(item.created_at)}</div>
                  <div className="timeline-item-sub">{item.empresa?.nombre || `Empresa #${item.empresa_id || 'N/A'}`}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditoriaDashboard;
